<template>
  <div class="steps4-content">
    <img
      src="../../../assets/image/password-success-icon.png"
      alt="密码重置成功"
    />
    <div>密码重置成功</div>
    <div @click="resetLogin">重新登录</div>
  </div>
</template>
<script>
export default {
  name: 'Steps1',
  methods: {
    resetLogin() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.steps4-content {
  text-align: center;
  > img {
    margin-bottom: 30px;
  }
  > div:nth-child(2) {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 60px;
  }
  > div:nth-child(3) {
    width: 152px;
    height: 38px;
    background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
    border-radius: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
  }
}
</style>
